
import { lazy, FC, LazyExoticComponent } from 'react';

// export { ProfilePage } from './profile/profile.jsx';
export { TasksPage } from './tasks/tasks.jsx';
export { TestPage } from './test/testPage';
export { WorkTime as WorkTimePage } from './worktime/worktime';
export { EasyPayMessage } from './easypay/easypayMessage.jsx';
export { ShedulerPage } from '../components/scheduler/scheduler.jsx';

const lazyImport = (pagePath: string): LazyExoticComponent<FC<any>> => lazy(() => import(`${pagePath}`));

export const lazyComponents: Record<string, LazyExoticComponent<FC<any>>> = {
  ActsPage: lazyImport('./acts/acts'),
  AdminkaPage: lazyImport('./adminka/adminka'),
  AdminkaReportsPage: lazyImport('./adminka/reports/reports'),
  ContractOffer: lazyImport('./contract-offer/contract-offer'),
  CRMPage: lazyImport('./crm'),
  DashboardPage: lazyImport('./dashboard/dashboard'),
  EasyPayList: lazyImport('./easypay/easypayList'),
  EPPage: lazyImport('./ep/ep'),
  EPOtkV2: lazyImport('./ep-main/ep-main-v2'),
  EPTachograph: lazyImport('./ep-main/tachograph/ep-tachograph'),
  HomePage: lazyImport('./home/home'),
  ImportCarsPage: lazyImport('./import-cars/index'),
  LabReportsPage: lazyImport('./lab-reports/lab-reports'),
  ManualMOC: lazyImport('./manual/manuals-moc'),
  ManualPage: lazyImport('./manual/manual-page'),
  NewsPage: lazyImport('./news/news'),
  OrderPage: lazyImport('./orders/order_v2'),
  OrdersPage: lazyImport('./orders/orders'),
  OrdersForPay: lazyImport('./orderForPay/orders'),
  OrderForPay: lazyImport('./orderForPay/OrderForPay'),
  // ВИМКНЕНО: сервер більше не віддає це поле (assurance не працює): Query.getAssurance
  // PolicyCard: lazyImport('./insurance-policy/card-policy/policyCard'),
  PriceOrdersPage: lazyImport('./price-orders/price-orders'),
  PriceOrderPage: lazyImport('./price-orders/price-order'),
  OpenOrderReport: lazyImport('./reports/openorder/openorder'),
  OrderCollectionsDoc: lazyImport('./orders/orderCollections/OrderCollectionsDoc'),
  OrderCollections: lazyImport('./orders/orderCollections/OrderCollections'),
  TerminalListDocsPage: lazyImport('./terminalListDocs/terminalListDocs'),
  WorkTimeListPage: lazyImport('./worktime/worktimeList'),
  TrustsPage: lazyImport('./trusts'),
  LabReportPage: lazyImport('./lab-reports/lab-report'),

  // JSX
  Diotrade: lazyImport('./ep-main/diotrade/diotrade.jsx'),
  FormOrderPage: lazyImport('./form-orders/form-order.jsx'),
  FormOrdersPage: lazyImport('./form-orders/form-orders.jsx'),
  EpCO2Form: lazyImport('./ep-main/CO2/ep-CO2.jsx'),
  EKMT: lazyImport('./ep-main/EKMT/ekmt.jsx'),
  // InsurancePriceList: lazyImport('./insurance-policy/priceList/prices.jsx'),
  // ВИМКНЕНО разом з assurance (Продаж СП)
  // PolicyPage: lazyImport('./insurance-policy/table/policy.jsx'),
  // ВИМКНЕНО разом з assurance (розділ неактуальний)
  // PolicyNew: lazyImport('./insurance-policy/new-policy/policyNew.jsx'),

  //reports
  CashFlowReport: lazyImport('./reports/cash-flow/cash-flow'),
  DebitsByAct: lazyImport('./reports/debits/debitsByAct'),
  DayLabReport: lazyImport('./reports/labreport/dayLabReport'),
  PayReport: lazyImport('./reports/payreport/payReport.jsx'),
  PriceList: lazyImport('./reports/pricelist/priceList'),

};


